export const status = (val) => (val ? 'Запущено' : 'Закрыто');
